import { LayoutCards } from '@flatsy/core/Layout/Cards'
import { getProgressionForApplication } from '@flatsy/utils/Functions/Files/GetApplicationDossierProgression'
import i18n from '@flatsy/utils/translations'
import React, { useContext, useEffect, useState } from 'react'
import { FileContext } from '../../Context'
import Step from './Step'
import { useStyles } from './Style'
import { stepProgression, stepProgressionReturn } from './Utils'

const Steppers: React.FC = (): React.ReactElement => {
  const classes = useStyles()
  const { applicants, files } = useContext(FileContext)
  const [stepperState, setStepperState] = useState<stepProgressionReturn>([
    'incomming',
    'incomming',
    'incomming',
  ])
  useEffect(() => {
    const progression = getProgressionForApplication({
      applicants: applicants.list,
      files: files.list,
    })
    setStepperState(stepProgression({ progression }))
  }, [applicants.list, files.list])

  return (
    <LayoutCards strongShadow className={classes.cards}>
      <Step name={i18n.t('documents_to_submit')} state={stepperState[0]} number={1} />
      <Step name={i18n.t('documents_under_review')} state={stepperState[1]} number={2} />
      <Step name={i18n.t('final_decision')} state={stepperState[2]} number={3} last />
    </LayoutCards>
  )
}

export default Steppers
